import React, { Component } from 'react';

import { CSSTransition } from 'react-transition-group';

//memberList
//グリッド表示
//クリックでviewモードへ、並び替えもここで行う
import MemberListMode from './MemberListMode.js';
import MemberInfoMode from './MemberInfoMode.js';
import MemberEditAndAddMode from './MemberEditAndAddMode.js';
import InfomationDisplayComponent from '../components/displayStateComponent/InfomationDisplayComponent.js';
import MemberDisplay from './MemberDisplay.js';

//create,edit
//同一レイアウト
//アイコン、名前、色選択

export default class MemberView extends Component{
    constructor(props){
        super(props);
        this.state = {
            workMode:'memberDisplay',

            editingMemberId:null,

            isInfoDisplayShown:false,
            infoDisplayImage:'',
            infoDisplayColor:'#55555',
            infoDisplayMessage:'',

        }
    }

    changeWorkMode = (targetMode) => {        
        this.setState({workMode:targetMode});
        this.props.onWorkModeChange(targetMode);
    }
    
    changeEditingMemberId = (targetId) => {        
        this.setState({editingMemberId:targetId});
    }

    showInfoDisplay = (image,color,message,time) => {        
        this.setState({
            isInfoDisplayShown:true,
            infoDisplayImage:image,
            infoDisplayColor:color,
            infoDisplayMessage:message,
        });
        setTimeout(() => {
            this.setState({isInfoDisplayShown:false});
        }, (typeof time !== 'undefined' ? time : 600 ) )
    }

    render(){

        //ワークモードは、バインドするものがそれぞれ違うので、React.createElementは使わない
        const memberComponentList = [
            {
                component:
                    <MemberListMode 
                    changeWorkMode={this.changeWorkMode} 
                    getEditMemberId={ (targetId) => this.changeEditingMemberId(targetId) }
                    onInfoDisplayCall={this.showInfoDisplay}
                    key="memberListMode"
                    />,
                workMode:'memberListMode'
            },
            {
                component:
                    <MemberDisplay 
                    onInfoDisplayCall={this.showInfoDisplay}
                    key="memberDisplay"
                    />,
                workMode:'memberDisplay'
            },
            {
                component:
                    <MemberInfoMode 
                    memberId={this.state.editingMemberId}
                    changeWorkMode={this.changeWorkMode}
                    key="memberInfoMode"
                    />,
                workMode:'memberInfoMode'
            },
            {
                component:
                    <MemberEditAndAddMode
                    memberId={this.state.editingMemberId}
                    changeWorkMode={this.changeWorkMode}
                    onInfoDisplayCall={this.showInfoDisplay}
                    key="memberEditAndAddMode"
                    />,
                workMode:'memberEditAndAddMode'
            },
        ]

        const viewFrameStyle = {height:'100%',position:'relative'};

        return (
            <div style={viewFrameStyle}>
              { memberComponentList.map( value =>  {
                  return (
                    <CSSTransition
                    in={value.workMode === this.state.workMode}
                    timeout={200}
                    classNames="mainViewCrossFade200"
                    unmountOnExit
                    mountOnEnter
                    key={value.workMode}
                    >
                      {value.component}
                    </CSSTransition>
                  )
              } ) }

              <CSSTransition
              in={this.state.isInfoDisplayShown}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                <InfomationDisplayComponent 
                image={this.state.infoDisplayImage} 
                fillColor={this.state.infoDisplayColor}
                message={this.state.infoDisplayMessage}
                />
              </CSSTransition>
              {/* { this.state.isInfoDisplayShown && (
                  <InfomationDisplayComponent 
                  image={this.state.infoDisplayImage} 
                  fillColor={this.state.infoDisplayColor}
                  message={this.state.infoDisplayMessage}
                  />
              )} */}
            </div>
        )
    }
}